module.exports = __webpack_public_path__ + "assets/img/4.ab16b370.png";